import { StoryblokBlockComponent } from "../../lib/storyblok/types/StoryblokComponent";
import { CarouselBlock } from "../../lib/storyblok/types/blocks/CarouselBlock";
import CarouselUi from "../../ui/Carousel/StackCarousel";
import Button from "../../ui/Button";
import { useLinks } from "../../lib/storyblok/useLinks";

const StackCarousel: StoryblokBlockComponent<CarouselBlock> = ({
  title,
  description,
  buttons,
  stackingItems,
  layout,
  inverted,
  spacing,
  outerSpacing,
}) => {
  const resolveLink = useLinks();

  const buttonCollection = buttons?.map((button) => (
    <Button
      variant={button.buttonType || "default"}
      key={button._uid}
      href={button.buttonLink ? resolveLink(button.buttonLink) : ""}
    >
      {button.buttonText}
    </Button>
  ));

  return (
    <CarouselUi
      title={title}
      description={description}
      buttons={buttonCollection}
      layout={layout}
      stackingItems={stackingItems}
      inverted={inverted}
      spacing={spacing}
      outerSpacing={outerSpacing}
    />
  );
};

export default StackCarousel;
